import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Extra from "./ExtraSec/Extra";

const Services = () => {
  return (
    <>
      <Header />
      <Extra />
      <Footer />
    </>
  );
};

export default Services;
